import React from 'react';
import Header from '../components/header/Header';
import VacanteDetail from '../components/vacantes/VacanteDetail';

function VacanteDetailPage() {
  return (
    <div className="App">
      <Header />
      <VacanteDetail />
    </div>
  );
}

export default VacanteDetailPage;
